import React, { useContext } from 'react'
import { withI18nContext } from '@mc/i18n'
import { SearchContext } from '../SearchContext'
import Results from './Results'
import Categories from './Categories'
import i18nInstance from '../i18n/i18nInstance'

const SearchResults = () => {
  const { category, showCategories, query } = useContext(SearchContext)
  const hasSearchValue = query.length > 0
  const hasCategory = !!category
  const displayCategories = showCategories && !hasCategory && !hasSearchValue
  return displayCategories ? <Categories /> : <Results />
}

export default withI18nContext(i18nInstance)(SearchResults)
